var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinnedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H1.66667C1.20833 0 0.833333 0.375 0.833333 0.833333C0.833333 1.29167 1.20833 1.66667 1.66667 1.66667H2.5V5.83333C2.5 7.21667 1.38333 8.33333 0 8.33333V10H4.975V15.8333L5.80833 16.6667L6.64167 15.8333V10H11.6667V8.33333C10.2833 8.33333 9.16667 7.21667 9.16667 5.83333V1.66667H10C10.4583 1.66667 10.8333 1.29167 10.8333 0.833333C10.8333 0.375 10.4583 0 10 0Z",
    fill: "#004895"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnedImg);
export default __webpack_public_path__ + "static/media/Pinned_img.bf28e2109156aa2373b672ae2a682737.svg";
export { ForwardRef as ReactComponent };